import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton';

const Modal = ({
  open,
  title = '',
  content = '',
  onSubmit = () => {},
  onClose = () => {},
  children,
  ...props
}) => {
  const actions = [
    <FlatButton
      label="Cancel"
      primary
      onTouchTap={onClose}
    />,
    <FlatButton
      label="Submit"
      primary
      keyboardFocused
      onTouchTap={onSubmit}
    />,
  ];
  return (
    <Dialog
      title={title}
      modal
      open={open}
      actions={actions}
      {...props}
    >
      {content}
      {children}
    </Dialog>
  )
}

Modal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.object,
}
Modal.defaultProps = {
  open: false,
  title: '',
  content: '',
  onSubmit: {},
  onClose: {},
  deleteContent: '',
  children: {},
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/modals/Modal.js